import React, { useState, useEffect, useMemo } from "react";
import "../Assests/Scss/Participation.scss";
import {
  AssessmentName, CAssessmentName,
} from "../../Student/Reusablecomponents/RegularFunctions";
import Loading from "../../Student/Reusablecomponents/Loading";
import InternetChecking from "../../Student/Reusablecomponents/Network";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import DropdownValues from "../../Student/Reusablecomponents/DropDownValues";
import { useNavigate } from "react-router-dom";
import { AllSubjectData } from "../../Redux/Reducers/HQAdmin/PerformanceOverallSubjects";
import { StateDetailsData } from "../../Redux/Reducers/HQAdmin/StatePerformanceDetails";
import SchoolTrends from "./SchoolTrends";
import { Row, Col } from "react-bootstrap";
import DistricTrends from "./DistrictTrends";
import { DistrictDetailsData } from "../../Redux/Reducers/HQAdmin/DistrictPerformanceDetails";
import XLSX from "xlsx-js-style";
import { RiFileExcel2Fill } from "react-icons/ri";
const DistrictPerformanceDrillDown = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const SelecteRegionData = useSelector(
    (state) => state.SubjectsData.RegionDetails
  );
  const SelectStatedata = useSelector(
    (state) => state.StateDetails.StateDetails
  );
  const SelectDistrictdata = useSelector(
    (state) => state.DistrictDetails.DistrictDetails
  );
  const SelectDate = useSelector((state) => state.DateDetailsData.DateDetails);


  const Colors = ["#629c23", "#435393", "#A03A13", "#d17373", "#FA897B", "#D0E6A5"];
  // const Colors = ["#9acb64", "#435393", "#d17373", "#FA897B", "#D0E6A5"];

  const [Load, SetLoad] = useState(false);
  const [NSData, SetNSData] = useState([]);
  const [RegionP, SetRegionP] = useState();
  const [StateWisedata, SetStateWisedata] = useState();
  const [RegionIds, SetRegionIds] = useState();

  const [DistrictWisedata, SetDistrictWisedata] = useState();
  const [StateIds, SetStateIds] = useState();

  const [SchoolsWisedata, SetSchoolsWisedata] = useState();
  const [DistrictIds, SetDistrictIds] = useState();
  const [SchoolIds, SetSchoolIds] = useState();

  const [Subjects, SetSubjects] = useState();
  const [SelectSUb, SetSelectSub] = useState();

  const [SelectRegionDetails, SetSelectRegionDetails] = useState({
    RegionName: SelecteRegionData?.[0]?.Region || SelecteRegionData?.[0]?.display,
    RegionId: SelecteRegionData?.[0]?.Regionid || SelecteRegionData?.[0]?.value,
  });
  // console.log(SelecteRegionData, "SelecteRegionData");
  const [SelctStateDetails, SetSelctStateDetails] = useState({
    StateName: SelectStatedata?.[0]?.display || SelectStatedata?.[0]?.Region,
    StateID: SelectStatedata?.[0]?.value || SelectStatedata?.[0]?.Regionid,
  });
  // console.log(SelectStatedata, "SelectStatedata");
  const [SelectDistrictDetails, SetSelectDistrictDetails] = useState({
    DistrictName: SelectDistrictdata?.[0]?.display || SelectDistrictdata?.[0]?.DistrictName,
    DistrictId: SelectDistrictdata?.[0]?.value || SelectDistrictdata?.[0]?.DistrictId,
  });

  const NationalPerformance = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/InstitutionAdmin/GetNationalPerformance?ContestCreationId=${SelectDate?.value}&AssessmentType=${SelectDate?.assessmentType}&InstituteId=${items?.instituteId}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data[0].subjectName) {
          NationalRegionPerformance();
          SetNSData(res.data);
        } else {
          SetSchoolsWisedata(process.env.REACT_APP_NODATAFOUND_Participated);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const NationalRegionPerformance = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/InstitutionAdmin/GetRegionPerformance?ContestCreationId=${SelectDate?.value}&AssessmentType=${SelectDate?.assessmentType}&InstituteId=${items?.instituteId}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const regions = [...new Set(res.data.map((item) => item.region))];
        const regionIDs = Array.from(
          res.data
            .reduce(
              (map, item) =>
                map.set(item.region, {
                  display: item.region,
                  value: item.regionId,
                }),
              new Map()
            )
            .values()
        );
        SetRegionIds(regionIDs);
        const subjects = [...new Set(res.data.map((item) => item.subjectName))];
        const regionData = regions.map((region) => {
          const regionSubjects = res.data.filter(
            (item) => item.region === region
          );
          const subjectPercentages = subjects.reduce((acc, subject) => {
            acc[subject] =
              regionSubjects.find((item) => item.subjectName === subject)
                ?.percentage || "N/A";
            return acc;
          }, {});
          return { region, ...subjectPercentages };
        });

        SetRegionP(regionData);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const StatePerformance = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/InstitutionAdmin/GetStatePerformance?ContestCreationId=${SelectDate?.value}&AssessmentType=${SelectDate?.assessmentType}&InstituteId=${items?.instituteId
        }&RegionId=${SelectRegionDetails?.RegionId || 0}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data[0].state) {
          const regions = [...new Set(res.data.map((item) => item.state))];
          const regionIDs = Array.from(
            res.data
              .reduce(
                (map, item) =>
                  map.set(item.state, {
                    display: item.state,
                    value: item.stateId,
                  }),
                new Map()
              )
              .values()
          );
          SetStateIds(regionIDs);
          if (
            SelecteRegionData?.[0]?.Regionid !== SelectRegionDetails?.RegionId
          ) {
            SetSelctStateDetails({
              StateName: regionIDs?.[0].display,
              StateID: regionIDs[0].value,
            });
          } else {
            // SetSelctStateDetails({
            //   StateName: SelectStatedata?.[0].Region || SelectStatedata?.[0].display,
            //   StateID: SelectStatedata?.[0].Regionid || SelectStatedata?.[0].value,
            // });
            const SSD = regionIDs?.filter(
              (item) => item.value === parseInt(SelctStateDetails?.StateID)
            );
            // console.log(SSD, "SSD", SSD?.length);
            if (SSD?.length > 0) {
              SetSelctStateDetails({
                StateName: SSD?.[0].display || SelectStatedata?.[0].Region || SelectStatedata?.[0].display,
                StateID: SSD?.[0]?.value || SelectStatedata?.[0].Regionid || SelectStatedata?.[0].value,
              });
            } else {
              SetSelctStateDetails({
                StateName: regionIDs?.[0].display,
                StateID: regionIDs[0].value,
              });

            }
          }
          const subjects = [
            ...new Set(res.data.map((item) => item.subjectName)),
          ];
          const regionData = regions.map((state) => {
            const regionSubjects = res.data.filter(
              (item) => item.state === state
            );
            const subjectPercentages = subjects.reduce((acc, subject) => {
              acc[subject] =
                regionSubjects.find((item) => item.subjectName === subject)
                  ?.percentage || "N/A";
              return acc;
            }, {});
            return { state, ...subjectPercentages };
          });
          SetStateWisedata(regionData);
          if (items.userTypeId === 8) {
            const singlestate = [];
            res.data.map((item) => {
              if (item.state === res.data[0].state) {
                singlestate.push(item);
              }
            });
            SetNSData(singlestate);
          }
        } else {
          SetSchoolsWisedata(process.env.REACT_APP_NODATAFOUND_Participated);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const DistrictPerformance = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/InstitutionAdmin/GetDistrictPerformance?ContestCreationId=${SelectDate?.value}&AssessmentType=${SelectDate?.assessmentType}&InstituteId=${items?.instituteId}&StateId=${SelctStateDetails?.StateID}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data[0].district) {
          const regions = [...new Set(res.data.map((item) => item.district))];
          const regionIDs = Array.from(
            res.data
              .reduce(
                (map, item) =>
                  map.set(item.district, {
                    display: `${item.district} (${item.totalSchools})`,
                    value: item.districtId,
                  }),
                new Map()
              )
              .values()
          );
          SetDistrictIds(regionIDs);
          // console.log(SelectStatedata?.[0].Regionid ,"-", SelctStateDetails?.StateID)
          // console.log(SelectDistrictdata, "SelectDistrictdata");
          if (SelectStatedata?.[0].Regionid !== SelctStateDetails?.StateID) {
            SetSelectDistrictDetails({
              DistrictName: SelectDistrictdata?.[0]?.display || SelectDistrictdata?.[0]?.DistrictName || regionIDs?.[0].display.split("(")[0].trim(),
              DistrictId: SelectDistrictdata?.[0]?.value || SelectDistrictdata?.[0]?.DistrictId || regionIDs[0].value,
            });
          } else {
            SetSelectDistrictDetails({
              DistrictName: SelectDistrictdata?.[0]?.display?.split("(")[0].trim() || SelectDistrictdata?.[0]?.DistrictName,
              DistrictId: SelectDistrictdata?.[0]?.value || SelectDistrictdata?.[0]?.DistrictId,
            });
          }
          const subjects = [
            ...new Set(res.data.map((item) => item.subjectName)),
          ];
          const regionData = regions.map((district) => {
            const regionSubjects = res.data.filter(
              (item) => item.district === district
            );
            const subjectPercentages = subjects.reduce((acc, subject) => {
              acc[subject] =
                regionSubjects.find((item) => item.subjectName === subject)
                  ?.percentage || "N/A";
              return acc;
            }, {});
            return { district, ...subjectPercentages };
          });
          SetDistrictWisedata(regionData);
        } else {
          SetSchoolsWisedata(process.env.REACT_APP_NODATAFOUND_Participated);
        }
        SetLoad((prev) => !prev);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const SchoolPerformance = async () => {
    SetSchoolIds();
    SetLoad((prev) => !prev);
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/InstitutionAdmin/GetSchoolPerformance?ContestCreationId=${SelectDate?.value}&AssessmentType=${SelectDate?.assessmentType}&InstituteId=${items?.instituteId}&Districtid=${SelectDistrictDetails?.DistrictId}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data[0].schoolName) {
          const regions = [...new Set(res.data.map((item) => item.schoolName))];
          const regionIDs = Array.from(
            res.data
              .reduce(
                (map, item) =>
                  map.set(item.schoolName, {
                    display: item.schoolName,
                    value: item.schoolId,
                  }),
                new Map()
              )
              .values()
          );
          SetSchoolIds(regionIDs);
          const subjects = [
            ...new Set(res.data.map((item) => item.subjectName)),
          ];
          SetSubjects(subjects);
          SetSelectSub(subjects[0]);
          const regionData = regions.map((schoolName) => {
            const regionSubjects = res.data.filter(
              (item) => item.schoolName === schoolName
            );
            let schoolId = null;
            const subjectPercentages = subjects.reduce((acc, subject) => {
              acc[subject] =
                regionSubjects.find((item) => item.subjectName === subject)
                  ?.percentage || "N/A";
              if (!schoolId) {
                schoolId = regionSubjects.find(
                  (item) => item.subjectName === subject
                )?.schoolId || "N/A";
              }
              return acc;
            }, {});
            return { schoolName, schoolId, ...subjectPercentages };
          });
          SetSchoolsWisedata(regionData);
        } else {
          SetSchoolsWisedata(process.env.REACT_APP_NODATAFOUND_Participated);
        }
        SetLoad(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (SelectDate?.value > 0) {
      if (items.userTypeId !== 8) {
        NationalPerformance();
      } else {
        if (items?.societyId) {
          GetScoietyPercentage();
        } else {
          StatePerformance();
        }
      }
    } else {
      SetSchoolsWisedata(process.env.REACT_APP_NODATAFOUND_Participated);
      SetRegionIds();
      SetStateIds();
      SetDistrictIds();
      SetSchoolIds();
    }
  }, [SelectDate?.value]);

  const RenderStateDetails = (e) => {
    const value = RegionIds.filter(
      (item) => item.value === parseInt(e.target.value)
    );
    SetSelectRegionDetails({
      RegionName: value[0].display,
      RegionId: e.target.value,
    });
    dispatch(
      AllSubjectData({
        RegionDetails: [
          {
            display: value[0].display,
            value: e.target.value,
          },
        ],
      })
    );
  };
  const RenderDistrictDetails = (e) => {
    const value = StateIds?.filter((item) => item.value === parseInt(e));
    SetSelctStateDetails({
      StateName: value?.[0].display,
      StateID: e,
    });
    dispatch(
      StateDetailsData({
        StateDetails: [
          {
            display: value?.[0].display,
            value: e,
          },
        ],
      })
    );
  };
  const RenderSchoolDetails = (e) => {
    const value = DistrictIds?.filter((item) => item.value === parseInt(e));
    SetSelectDistrictDetails({
      DistrictName: value?.[0].display.split("(")[0].trim(),
      DistrictId: e,
    });
  };

  useMemo(() => {
    if (SelectDate?.value > 0 && items?.societyId <= 0) {
      SetLoad((prev) => !prev);
      StatePerformance();
    }
  }, [SelectRegionDetails, RegionP]);

  useMemo(() => {
    if (SelectDate?.value > 0 && SelctStateDetails.StateID) {
      DistrictPerformance();
    }
  }, [SelctStateDetails]);

  useMemo(() => {
    if (SelectDate?.value > 0 && SelectDistrictDetails?.DistrictId) {
      SchoolPerformance();
    }
  }, [SelectDistrictDetails]);

  // Below is scosity releated

  const GetScoietyPercentage = async () => {
    SetLoad((prev) => !prev);
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/InstitutionAdmin/GetSocietyWisePerformance?ContestCreationId=${SelectDate?.value}&AssessmentType=${SelectDate?.assessmentType}&InstituteId=${items?.instituteId}&SocietyId=${items?.societyId}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data[0].subjectName) {
          SetNSData(res.data);
          ScoietyDistrictPerformance();
        } else {
          SetSchoolsWisedata(process.env.REACT_APP_NODATAFOUND_Participated);
          SetLoad(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const ScoietyDistrictPerformance = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/InstitutionAdmin/GetSocietyWiseDistrictPerformance?ContestCreationId=${SelectDate?.value}&AssessmentType=${SelectDate?.assessmentType}&InstituteId=${items?.instituteId}&SocietyId=${items?.societyId}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data[0].district) {
          const regionIDs = Array.from(
            res.data
              .reduce(
                (map, item) =>
                  map.set(item.district, {
                    display: `${item.district} (${item.totalSchools})`,
                    value: item.districtId,
                  }),
                new Map()
              )
              .values()
          );
          SetDistrictIds(regionIDs);

          const formattedData = res.data.reduce((acc, curr) => {
            const { district, subjectName, percentage } = curr;
            if (!acc[district]) {
              acc[district] = { district };
            }
            acc[district][subjectName] = percentage;
            return acc;
          }, {});

          const finalArray = Object.values(formattedData);
          SetDistrictWisedata(finalArray);
          SocietySchoolPerformance();
        } else {
          SetSchoolsWisedata(process.env.REACT_APP_NODATAFOUND_Participated);
        }
        SetLoad((prev) => !prev);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const SocietySchoolPerformance = async () => {
    SetSchoolIds();
    SetLoad((prev) => !prev);
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/InstitutionAdmin/GetSocietyWiseSchoolPerformance?ContestCreationId=${SelectDate?.value}&AssessmentType=${SelectDate?.assessmentType}&InstituteId=${items?.instituteId}&Districtid=${SelectDistrictDetails?.DistrictId}&SocietyId=${items?.societyId}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data[0].schoolName) {
          const regionIDs = Array.from(
            res.data
              .reduce(
                (map, item) =>
                  map.set(item.schoolName, {
                    display: item.schoolName,
                    value: item.schoolId,
                  }),
                new Map()
              )
              .values()
          );
          SetSchoolIds(regionIDs);
          const subjects = [
            ...new Set(res.data.map((item) => item.subjectName)),
          ];
          SetSubjects(subjects);
          SetSelectSub(subjects[0]);
          const formattedData = res.data.reduce((acc, curr) => {
            const { schoolName, subjectName, percentage, schoolId, userId } = curr;
            if (!acc[schoolName]) {
              acc[schoolName] = { schoolName, schoolId, userId };
            }
            acc[schoolName][subjectName] = percentage;
            return acc;
          }, {});

          const finalArray = Object.values(formattedData);
          SetSchoolsWisedata(finalArray);
        } else {
          SetSchoolsWisedata(process.env.REACT_APP_NODATAFOUND_Participated);
        }
        SetLoad(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  // Above is scosity releated
  const NTPrinciple = (SID) => {
    const Details = {
      SchoolName: SID?.schoolName,
      SchoolId: SID?.schoolId,
      UserId: SID?.userId,
    };
    localStorage.setItem("NTP", JSON.stringify(Details));
    navigate(`/InstitutionAdmin/Performance/SWResults`);
  };
  // useMemo(() => {
  //   dispatch(DistrictDetailsData({
  //     DistrictDetails:[ {
  //       DistrictName: SelectDistrictDetails?.DistrictName || SelectDistrictdata?.[0]?.display?.split("(")[0].trim() || SelectDistrictdata?.[0]?.DistrictName,
  //       DistrictId: SelectDistrictDetails?.DistrictId || SelectDistrictdata?.[0]?.value || SelectDistrictdata?.[0]?.DistrictId,
  //     }]
  //   }));
  // }, [SelectDistrictDetails]);

  useMemo(() => {
    dispatch(
      AllSubjectData({
        RegionDetails: [
          {
            Region: SelectRegionDetails?.RegionName,
            Regionid: SelectRegionDetails?.RegionId,
          },
        ],
      })
    );
    dispatch(StateDetailsData({
      StateDetails: [
        { display: SelctStateDetails?.StateName, value: SelctStateDetails?.StateID },],
    }));
    dispatch(DistrictDetailsData({
      DistrictDetails: [{
        DistrictName: SelectDistrictDetails?.DistrictName || SelectDistrictdata?.[0]?.display?.split("(")[0].trim() || SelectDistrictdata?.[0]?.DistrictName,
        DistrictId: SelectDistrictDetails?.DistrictId || SelectDistrictdata?.[0]?.value || SelectDistrictdata?.[0]?.DistrictId,
      }]
    }));
  }, [SelectRegionDetails, SelctStateDetails, SelectDistrictDetails]);
  //  4th May 2026 Export the table data in Excel Format
  const exportToExcel = () => {
    const table = document.getElementById("performanceTable");

    if (!table) {
      alert("Table not found!");
      return;
    }

    const worksheet = XLSX.utils.table_to_sheet(table, { raw: true });
    const range = XLSX.utils.decode_range(worksheet["!ref"]);

    for (let R = range.s.r; R <= range.e.r; R++) {
      for (let C = range.s.c; C <= range.e.c; C++) {
        const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });

        if (!worksheet[cellAddress]) continue;

        worksheet[cellAddress].s = {
          border: {
            top: { style: "thin", color: { rgb: "000000" } },
            bottom: { style: "thin", color: { rgb: "000000" } },
            left: { style: "thin", color: { rgb: "000000" } },
            right: { style: "thin", color: { rgb: "000000" } },
          },
        };
      }
    }

    if (worksheet["A1"]) {
      worksheet["A1"].s = {
        ...worksheet["A1"].s,
        font: {
          bold: true,
        },
        alignment: {
          horizontal: "center",
          vertical: "center",
        },
      };
    }
    const SecondRow = items.userTypeId !== 8 ? "A7" : "A5"
    if (worksheet[SecondRow]) {
      worksheet[SecondRow].s = {
        ...worksheet[SecondRow].s,
        font: {
          bold: true,
        },
      };
    }

    for (let C = range.s.c; C <= range.e.c; C++) {
      const cellAddress = XLSX.utils.encode_cell({
        r: 1,
        c: C,
      });

      if (!worksheet[cellAddress]) continue;

      worksheet[cellAddress].s = {
        ...worksheet[cellAddress].s,
        font: {
          ...(worksheet[cellAddress].s?.font || {}),
          bold: true,
        },
        alignment: {
          horizontal: "center",
          vertical: "center",
        },
      };
    }
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, `District Performance`);


    XLSX.writeFile(workbook, `District Performance ${SelectDate?.assessmentTypeName}_${SelectDate?.examStartDate}.xlsx`);
  };
  return (
    <>
      <div className="TeacherBgImage">
        <InternetChecking />
        <div className="dflex JSBetween alignitems">
          <div></div>
          <div className="MainHeading mt-2">
            {SelectDistrictDetails.DistrictName} District Performance in {CAssessmentName(SelectDate?.assessmentType)} - {SelectDate?.examStartDate}
          </div>
          {/*   4th May 2026 Trigger the export excel function */}
          <div className="ExportExcel" onClick={() => exportToExcel()}>{SchoolsWisedata?.[0]?.schoolName && <RiFileExcel2Fill />} </div>
        </div>
        <div className="dflex mt-2" style={{ alignItems: "center", justifyContent: "center" }}>
          <b> <span >{SelectRegionDetails?.RegionName ? <> <span className="CPointer text-decoration-underline" onClick={() => navigate(-3)} style={{ color: "#696969" }}>National</span>{""} &gt; {""} <span className="CPointer text-decoration-underline" onClick={() => navigate(-2)} style={{ color: "#696969" }}>{SelectRegionDetails?.RegionName}</span>{""} &gt; {""}</> : ""}</span>
            <span className="CPointer text-decoration-underline" onClick={() => navigate(-1)} style={{ color: "#696969" }}>{items?.societyId <= 0 ? SelctStateDetails?.StateName : items?.societyName} </span> {""} &gt; {""}  <span style={{ color: "#00009A" }}> {SelectDistrictDetails?.DistrictName}</span></b>
        </div>
        <div className="dflex JSBetween mb-2 mt-1">
          {items?.societyId ? (
            <div className="SubHeading"> <b>Society : </b> {items?.societyName} </div>
          ) : (
            <div></div>
          )}
          <div className="dflex gap-3">
            {RegionIds && (<div className="dflex gap-2">
              <div className="DropdownHeader">Region: </div>
              <DropdownValues
                className="NCLDropdown"
                options={RegionIds}
                onChange={(e) => RenderStateDetails(e)}
                selectoption={SelectRegionDetails?.RegionId}
              />
            </div>
            )}
            {(items?.instituteId === 2 || items?.instituteId === 4 || items?.instituteId === 7) ? ""
              :
              StateIds && (<div className="dflex gap-2">
                <div className="DropdownHeader">State: </div>
                {StateIds?.length === 1 ? <input type="text" className="NCLDropdown" value={SelctStateDetails.StateName} /> :
                  <DropdownValues
                    className="NCLDropdown"
                    options={StateIds}
                    onChange={(e) => RenderDistrictDetails(e.target.value)}
                    selectoption={SelctStateDetails.StateID}
                  />}</div>
              )}
            {DistrictIds && (<div className="dflex gap-2">
              <div className="DropdownHeader">District: </div>
              {DistrictIds?.length === 1 ? <input type="text" className="NCLDropdown" value={DistrictIds?.filter((item) => item.value === SelectDistrictDetails?.DistrictId)?.[0]?.display || SelectDistrictDetails?.DistrictName} /> :

                <DropdownValues
                  className="NCLDropdown"
                  options={DistrictIds}
                  onChange={(e) => RenderSchoolDetails(e.target.value)}
                  selectoption={SelectDistrictDetails.DistrictId}
                />}
            </div>
            )}

          </div>
        </div>
        <div className="Table-Card">
          {SchoolsWisedata?.[0]?.schoolName ? (
            <table className="w-100 Inst_Performance-Table" id="performanceTable">
              <thead>
                <tr>
                  {/* {SelectDistrictDetails.DistrictName} District */}
                  <th colSpan={NSData?.length + 1} >
                    Performance report
                  </th>
                </tr>
                <tr>
                  <th></th>
                  {NSData?.map((item, index) => (
                    <th key={index} >{item.subjectName}(%)</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {/* National Level */}
                <tr style={{ color: "#7030a0" }}>
                  {/* <tr style={{ color: "#205680" }}> */}
                  <th className="ft-18 CPointer text-decoration-underline" onClick={() => { items.userTypeId !== 8 ? navigate(-3) : navigate(-1) }}>
                    {items.userTypeId !== 8
                      ? "National"
                      : items?.societyId
                        ? NSData?.[0]?.society
                        : <>{SelctStateDetails?.StateName} State </>}
                  </th>
                  {NSData?.map((item, index) => (
                    <td key={index}>{item.percentage}%</td>
                  ))}
                </tr>

                {(items.userTypeId !== 8
                  ? [
                    {
                      level: "region",
                      data: RegionP,
                      key: SelectRegionDetails?.RegionName,
                      Colour: "#008080",
                      Click: () => navigate(-2),
                    },
                    {
                      level: "state",
                      data: StateWisedata,
                      key: SelctStateDetails?.StateName,
                      Colour: "#435393",
                      Click: () => navigate(-1),
                    },
                    {
                      level: "district",
                      data: DistrictWisedata,
                      key: SelectDistrictDetails?.DistrictName,
                      Colour: "#A03A13"
                    },
                  ]
                  : [
                    {
                      level: "district",
                      data: DistrictWisedata,
                      key: SelectDistrictDetails?.DistrictName,
                      Colour: "#A03A13"
                    },
                  ]
                ).map(({ level, data, key, Colour, Click }, levelIndex) => (
                  <tr key={levelIndex} style={{ color: Colour }}>
                    {" "}
                    <th className={Click ? "CPointer text-decoration-underline" : ""} onClick={Click}>
                      {key}
                    </th>
                    {/* style={{ color: Colors[levelIndex] }} */}
                    {data?.map(
                      (item) =>
                        item[level] === key &&
                        NSData?.map((subject, index) => (
                          <td key={index}>
                            {item[subject.subjectName] === "N/A" ||
                              item[subject.subjectName] === undefined
                              ? "-"
                              : item[subject.subjectName] + "%"}
                          </td>
                        ))
                    )}
                  </tr>
                ))}

                <tr>
                  <th
                    colSpan={NSData?.length + 1}
                    style={{ textAlign: "justify" }}
                  >
                    {SelectDistrictDetails.DistrictName} District - School
                    performance
                  </th>
                </tr>
                {SchoolsWisedata?.map((item, index) => (
                  <tr key={index}>
                    <th style={{ color: Colors[2] }}
                      className="text-decoration-underline CPointer"

                      onClick={() => NTPrinciple(item)}
                    // onClick={() => NTPrinciple(item.schoolId)} "#259957"
                    >
                      {item.schoolName}
                    </th>
                    {NSData?.map((Subject, index) => (
                      <td key={index}>
                        {item[Subject.subjectName] === "N/A" ||
                          item[Subject.subjectName] === undefined
                          ? "-"
                          : item[Subject.subjectName] + "%"}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className="ErrorMessage">{SchoolsWisedata}</div>
          )}
        </div>
        <div className="SubHeading mt-3">
          District vs School performance trends
        </div>
        <div className="container-fluid">
          <Row className=" Card mt-3 dflex" style={{ gap: "10px" }}>
            <div className="dflex RegionSub-Navigations">
              {Subjects?.map((item, index) => (
                <span
                  key={index}
                  onClick={() => {
                    SetSelectSub(item);
                  }}
                  style={
                    SelectSUb !== item
                      ? { color: "#878997", backgroundColor: "#f5f5f5" }
                      : {}
                  }
                >
                  {item}
                </span>
              ))}
            </div>
            <Col style={{ borderRight: "1px solid #CBCBCB" }}>
              {" "}
              <DistricTrends
                AType={SelectDate?.assessmentType}
                SubSelect={SelectSUb}
                SelecteDistrict={SelectDistrictDetails}
                DistrictIds={DistrictIds}
              />{" "}
            </Col>
            <Col>
              {" "}
              {SchoolIds && (
                <SchoolTrends
                  AType={SelectDate?.assessmentType}
                  SubSelect={SelectSUb}
                  SelectedDistrict={SelectDistrictDetails}
                  SchoolIds={SchoolIds}
                />
              )}{" "}
            </Col>
          </Row>
        </div>
      </div>
      {Load && <Loading />}
    </>
  );
};
export default DistrictPerformanceDrillDown;
